import { render } from "./Letter.vue?vue&type=template&id=c1785228"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"

import "./Letter.vue?vue&type=style&index=0&id=c1785228&lang=scss"

import exportComponent from "/Users/Max/Documents/Projekte/slf-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__